import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-survey-help-modal',
  templateUrl: './survey-help-modal.component.pug',
  styleUrls: ['./survey-help-modal.component.scss'],
  standalone: false
})
export class SurveyHelpModalComponent implements OnInit {
  constructor(
    private modalService: BsModalService,
    private permissions:PermissionsService
  ) {}

  ngOnInit(): void {
  }

  closeModal(): void {
    this.modalService.hide()
  }
}
